import React, { useEffect, useState } from 'react';
import { Container, Button } from './styles';
import StarIcon from '../../../../assets/Modals/StartIcon/StarIcon';
import EditIcon from '../../../../assets/Modals/EditIcon';
import DisableCommentsIcon from '../../../../assets/Modals/DisableCommentsIcon';
import DeleteIcon from '../../../../assets/Modals/DeleteIcon';
import Denounce from '../../../../assets/Modals/Denounce';

type ChatModalProps = {
  open: boolean;
  authorUsername: string;
  onAction: any;
};

export default function ChatModal({ open, authorUsername, onAction }: ChatModalProps) {

  return (
    <>
      {open && (
        <Container>
          <Button delete={true}>
            <BlockIcon />
            Bloquear usuário
          </Button>
          <Button delete={true}>
            <Denounce />
            Denunciar
          </Button>
          <Button delete={true} onClick={() => onAction('delete')}>
            <DeleteIcon />
            Excluir
          </Button>
        </Container>
      )}
    </>
  );
}

function BlockIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <g
        stroke="#F33333"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.333"
        clipPath="url(#clip0_2951_27405)"
      >
        <path d="M8 14.666A6.667 6.667 0 108 1.333a6.667 6.667 0 000 13.333zM3.287 3.286l9.426 9.427"></path>
      </g>
      <defs>
        <clipPath id="clip0_2951_27405">
          <path fill="#fff" d="M0 0H16V16H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}